const {
  traverseFormContent
} = require('../lib/getFormContent');

/**
  * @function evaluate - evaluate readReferencedContentBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const {
    value
  } = await traverseFormContent(source, content, parentContentPath, transientContext, nativeFunctions);
  return value;
};
module.exports = {
  evaluate
};